import React from 'react';

import styled, { keyframes } from 'styled-components';
import { StyledTypography } from 'styles/common';

import { TeamColored } from 'constants/icons';

export default function FeedLoadingView() {
  return (
    <Container>
      <Content>
        <TeamColored size="medium" />
        <StyledTypography topGutter={2} bottomGutter={2} color="textSecondary" weight={600}>
          Save your team from multiple project plans and endless update calls, one post at a time!
        </StyledTypography>
      </Content>
      {/* <ColoredCircularProgress size="smallest" color="primary" /> */}
    </Container>
  );
}

const Container = styled.div`
  text-align: center;
  padding: 4rem;
`;

const visibileInvisible = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Content = styled.div`
  animation: ${visibileInvisible} 1s infinite;
  animation-direction: alternate;
`;
